var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "status-details" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "events" }, [
        _c(
          "ul",
          _vm._l(_vm.events, function(event) {
            return _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm._f("getStatusName")(_vm.eventName(event.event_type))
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formattedDate(event.created_at)))])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _vm.isWaitingForDocuments
          ? _c(
              "v-tooltip",
              {
                attrs: { bottom: "", disabled: _vm.canSendDocsToAnalysis },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "span",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    disabled: !_vm.canSendDocsToAnalysis,
                                    loading: _vm.preloader
                                  },
                                  on: { click: _vm.sendDocsToAnalysis }
                                },
                                [
                                  _vm._v(
                                    "\n            Enviar documentos para análise\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3296461900
                )
              },
              [
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "O profissional ainda não enviou os documentos ou eles foram\n        recusados."
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isValidDocuments
          ? _c(
              "div",
              { attrs: { bottom: "" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      small: "",
                      loading: _vm.preloader
                    },
                    on: { click: _vm.checkBackgroundCheck }
                  },
                  [
                    _vm._v(
                      "\n        Solicitar análise dos antecedentes\n      "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isWaitingDocumentsValidation
          ? _c(
              "div",
              { attrs: { bottom: "" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      small: "",
                      loading: _vm.preloader
                    },
                    on: { click: _vm.checkDocOnDataAssuranceService }
                  },
                  [
                    _vm._v(
                      "\n        Atualizar status dos documentos no CAF\n      "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isInvalidDocuments
          ? _c(
              "div",
              { attrs: { bottom: "" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      small: "",
                      loading: _vm.preloader
                    },
                    on: { click: _vm.requestNewDocuments }
                  },
                  [
                    _vm._v(
                      "\n        Solicitar novo envio de documentos\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "error",
                      small: "",
                      loading: _vm.preloader
                    },
                    on: { click: _vm.denyProfessionalAccess }
                  },
                  [_vm._v("\n        Negar acesso a plataforma\n      ")]
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n      Nessa etapa o profissional deve enviar os seus documentos e nós devemos\n      enviá-lo para o serviço que verifica a sua autenticidade. Caso o\n      documentos se encontre no estado de reprovado você poderá\n      "
      ),
      _c("b", [_vm._v("recusar")]),
      _vm._v(
        " o cadastro do profissional negando o seu acesso a\n      plataforma ou "
      ),
      _c("b", [_vm._v("solicitar um novo envio")]),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e15374e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e15374e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/DocumentValidation.vue
// module id = null
// module chunks = 